import { UserSessionsForDebugApi } from "../../generated"
import { apiConfig } from "../apiConfig"
import { useCallback, useState } from "react"
import { useLocation } from "wouter"

const api = new UserSessionsForDebugApi(apiConfig)

export interface DebugApplicantSignInRequest {
  email: string
}

export function useDebugApplicantSignIn() {
  const [loginError, setLoginError] = useState<boolean>(false)
  const [, setLocation] = useLocation()
  const signIn = useCallback((data: DebugApplicantSignInRequest) => {
    api.applicantSignIn(data.email)
      .then(_ => {
        console.debug('success. you are now login.')

        setLoginError(false)
        // location.reload()
        setLocation('/login')
        location.reload()
      }).catch(err => {
        setLoginError(true)
        console.error('エラーが発生しました。対応未実装')
        console.error(err)

      })
  }, [setLocation])
  return { loginError, signIn }
}
